import { render, staticRenderFns } from "./ContactUs-content.vue?vue&type=template&id=6c8a564c&scoped=true"
import script from "./ContactUs-content.vue?vue&type=script&lang=js"
export * from "./ContactUs-content.vue?vue&type=script&lang=js"
import style0 from "./ContactUs-content.vue?vue&type=style&index=0&id=6c8a564c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a564c",
  null
  
)

export default component.exports